import gql from 'graphql-tag';

const CREATE_USAGE_SHEET = gql`
  mutation createUsageSheet(
    $caseId: String
    $caseExternalId: String
    $eventExternalId: String
    $eventSFID: String
    $division: String
    $branchId: String!
    $accountId: String!
    $procedureTypeIds: String
    $surgeonId: String
    $alignedSurgeonId: String
    $salesRepId: String!
    $eventType: String
    $shipToId: String
    $billToId: String
    $eventDateTime: Date
    $poNumber: String
    $patientId: String
    $formType: String!
    $shipMethod: String
    $requestedFrom: String
    $comments: [Comment]
    $lineItems: [InventoryLineItem]
    $attachments: [Attachment]
    $expectedCaseVersion: String
    $system: String
    $version: String
  ) {
    createUsageSheet(
      division: $division
      caseId: $caseId
      caseExternalId: $caseExternalId
      eventSFID: $eventSFID
      eventExternalId: $eventExternalId
      branchId: $branchId
      accountId: $accountId
      procedureTypeIds: $procedureTypeIds
      surgeonId: $surgeonId
      alignedSurgeonId: $alignedSurgeonId
      salesRepId: $salesRepId
      eventType: $eventType
      eventDateTime: $eventDateTime
      shipToId: $shipToId
      billToId: $billToId
      poNumber: $poNumber
      patientId: $patientId
      formType: $formType
      shipMethod: $shipMethod
      requestedFrom: $requestedFrom
      comments: $comments
      lineItems: $lineItems
      attachments: $attachments
      expectedCaseVersion: $expectedCaseVersion
      system: $system
      version: $version
    ) {
      message
      externalId
      sfid
    }
  }
`;

export default CREATE_USAGE_SHEET;
